import * as React from 'react'

import moment from 'moment'
import { getDurationBetweeenDates, formatDateTime } from 'app/common/dateHelper'
import { WeekRecompenseModel } from 'app/models/weekRecompenseModel'
import { TooltipLayout } from './ToolTipLayout'

type WeekRecompenseTooltipProps = {
  weekRecompense: WeekRecompenseModel
  translate: (text) => any
}
type WeekRecompenseTooltipState = {}

export class WeekRecompenseTooltip extends React.Component<
  WeekRecompenseTooltipProps,
  WeekRecompenseTooltipState
> {
  constructor(props: WeekRecompenseTooltipProps) {
    super(props)
  }

  render() {
    const {
      startTime,
      typeName,
      restStartTimeTheRecompenseBelongsTo,
      realRestEndTime,
      color,
    } = this.props.weekRecompense

    const rows = [
      {
        title: this.props.translate('event.duration'),
        value: getDurationBetweeenDates(
          moment(startTime).toDate(),
          moment(realRestEndTime).toDate(),
        ),
      },
      {
        title: this.props.translate('event.startTime'),
        value: formatDateTime(startTime),
      },
      {
        title: this.props.translate('event.endTime'),
        value: formatDateTime(realRestEndTime),
      },
      {
        title: this.props.translate('event.forDay'),
        value: formatDateTime(restStartTimeTheRecompenseBelongsTo),
      },
    ]

    return (
      <TooltipLayout
        headerColor={color}
        headerTitle={this.props.translate(typeName).toString()}
        rows={rows}
      />
    )
  }
}
